<template>
    <TabBasic :key="$route.name" :actual-breadcrumb="breadcrumb" :items="items" replace-route show-breadcrumbs>
    </TabBasic>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";

export default {
  name: "CircleEditBasic",
  components: {TabBasic},
  data() {
    return {
      circle: {},
    };
  },
  computed: {
    isCircleDetail() {
      return ['circleEdit', 'circleHistory'].includes(this.$route.name);
    },
    breadcrumb() {
      if (!this.isCircleDetail) {
        return null;
      }
      let suffix = this.$t('tooltips.members');
      if (this.$route.name === 'circleHistory') {
        suffix = this.$t('tooltips.circleHistory');
      }
      if (this.circle && this.circle.Name) {
        return [{
          text: `${this.circle.Name} - ${suffix}`,
          disabled: false,
        }];
      }
      return [{
        text: suffix,
        disabled: false,
      }];
    },
    items() {
      if (!this.isCircleDetail) {
        return [];
      }
      const id = this.$route.params.id;
      return [
        {
          title: this.$t('tooltips.members'),
          to: {
            name: 'circleEdit',
            params: {id},
          },
        },
        {
          title: this.$t('tooltips.circleHistory'),
          to: {
            name: 'circleHistory',
            params: {id},
          },
        },
      ];
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        if (id && this.isCircleDetail) {
          this.initCircle();
        }
      },
    },
  },
  methods: {
    initCircle() {
      const id = this.$route.params.id;
      if (!id) {
        return;
      }
      const url = this.$store.getters.circles(this.$store.getters.getOrganizationId, id);
      this.axios.get(url).then(({data}) => {
        this.circle = data.Result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
